// OfficeChatTabs.jsx
import React, { useEffect, useMemo, useRef, useState } from "react";

const TABS = [
    { key: "all", label: "Все чаты" },
    { key: "direct", label: "Личные" },
    { key: "group", label: "Общие" },
    { key: "product", label: "Товары" },
    { key: "order", label: "Заказы" },
];

const normalizeStat = (value) => {
    if (typeof value === "number") {
        return {
            total: value,
            unread: 0,
        };
    }

    return {
        total: Number(value?.total || 0),
        unread: Number(value?.unread || 0),
    };
};

const formatCount = (value) => {
    const count = Number(value || 0);

    if (count > 99) return "99+";

    return String(count);
};

export default function OfficeChatTabs({ value = "all", onChange, counts = {}, variant = "dropdown" }) {
    const rootRef = useRef(null);
    const [open, setOpen] = useState(false);

    const activeTab = useMemo(
        () => TABS.find((tab) => tab.key === value) || TABS[0],
        [value]
    );

    const activeStat = normalizeStat(counts?.[activeTab.key]);

    useEffect(() => {
        if (!open) return undefined;

        const handlePointerDown = (event) => {
            if (!rootRef.current?.contains(event.target)) {
                setOpen(false);
            }
        };

        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                setOpen(false);
            }
        };

        document.addEventListener("pointerdown", handlePointerDown);
        document.addEventListener("keydown", handleKeyDown);

        return () => {
            document.removeEventListener("pointerdown", handlePointerDown);
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [open]);

    const handleSelect = (key) => {
        setOpen(false);

        if (key !== activeTab.key) {
            onChange?.(key);
        }
    };

    if (variant === "menu") {
        return (
            <div className="office-chat-tabs-AO office-chat-tabs-AO--menu-list">
                <div className="office-chat-tabs-AO__section-title">Показывать</div>

                <div className="office-chat-tabs-AO__menu-options" role="listbox" aria-label="Тип чатов">
                    {TABS.map((tab) => {
                        const stat = normalizeStat(counts?.[tab.key]);
                        const active = tab.key === activeTab.key;

                        return (
                            <button
                                key={tab.key}
                                type="button"
                                role="option"
                                aria-selected={active}
                                className={`office-chat-tabs-AO__option${active ? " is-active" : ""}`}
                                onClick={() => handleSelect(tab.key)}
                            >
                                <span className="office-chat-tabs-AO__option-label">{tab.label}</span>

                                <span className="office-chat-tabs-AO__option-meta">
                                    <span className="office-chat-tabs-AO__option-count">
                                        {formatCount(stat.total)}
                                    </span>

                                    {stat.unread > 0 && (
                                        <span className="office-chat-tabs-AO__option-unread">
                                            {formatCount(stat.unread)}
                                        </span>
                                    )}
                                </span>
                            </button>
                        );
                    })}
                </div>
            </div>
        );
    }

    return (
        <div className="office-chat-tabs-AO" ref={rootRef}>
            <button
                type="button"
                className={`office-chat-tabs-AO__trigger${open ? " is-open" : ""}`}
                onClick={() => setOpen((state) => !state)}
                aria-haspopup="listbox"
                aria-expanded={open}
                title="Выбрать тип чатов"
            >
                <span className="office-chat-tabs-AO__label">{activeTab.label}</span>

                <span className="office-chat-tabs-AO__count">
                    {formatCount(activeStat.total)}
                </span>

                {activeStat.unread > 0 && (
                    <span className="office-chat-tabs-AO__unread" aria-label={`Непрочитанных: ${activeStat.unread}`}>
                        {formatCount(activeStat.unread)}
                    </span>
                )}

                <span className="office-chat-tabs-AO__chevron" aria-hidden="true">⌄</span>
            </button>

            {open && (
                <div className="office-chat-tabs-AO__menu" role="listbox" aria-label="Тип чатов">
                    {TABS.map((tab) => {
                        const stat = normalizeStat(counts?.[tab.key]);
                        const active = tab.key === activeTab.key;

                        return (
                            <button
                                key={tab.key}
                                type="button"
                                role="option"
                                aria-selected={active}
                                className={`office-chat-tabs-AO__option${active ? " is-active" : ""}`}
                                onClick={() => handleSelect(tab.key)}
                            >
                                <span className="office-chat-tabs-AO__option-label">{tab.label}</span>

                                <span className="office-chat-tabs-AO__option-meta">
                                    <span className="office-chat-tabs-AO__option-count">
                                        {formatCount(stat.total)}
                                    </span>

                                    {stat.unread > 0 && (
                                        <span className="office-chat-tabs-AO__option-unread">
                                            {formatCount(stat.unread)}
                                        </span>
                                    )}
                                </span>
                            </button>
                        );
                    })}
                </div>
            )}
        </div>
    );
}
